"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _utils = require("../utils/utils");

var _default = {
  title: 'Overlay Hover Animation',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.hoveringBehaviour !== _constants.GALLERY_CONSTS.infoBehaviourOnHover.NO_CHANGE && styleParams.hoveringBehaviour !== _constants.GALLERY_CONSTS.infoBehaviourOnHover.NEVER_SHOW;
  },
  type: _constants.INPUT_TYPES.OPTIONS,
  "default": _constants.GALLERY_CONSTS.overlayAnimations.NO_EFFECT,
  options: (0, _utils.createOptions)('overlayAnimations'),
  description: "Choose the overlay animation effect to be used when hovering over an item"
};
exports["default"] = _default;